/* Product back link / breadcrumb (snippets/product-back-link.liquid).
 *
 * Decides which collection the visitor came from and rewrites the server
 * rendered default ("Tilbage til <catalogue>") into a breadcrumb of that
 * collection and its menu parents.
 *
 * Context is taken from, in order:
 *  1. The collection in the URL (/collections/x/products/y), rendered server side.
 *  2. The collection remembered by snippets/product-back-link-recorder.liquid,
 *     but only while the visitor is still inside that browsing trail: the
 *     previous page was that collection, or the previous page was the product
 *     that was itself opened from it (collection -> product -> recommended
 *     product). Anything else (ad, search engine, home page) falls back to the
 *     default catalogue.
 *
 * Clicking the collection uses history.back() when it was the page right
 * before this one, so scroll position, filters and loaded pages survive.
 * Either way it leaves a one-shot "return" flag in sessionStorage so the
 * collection restores its loaded pages and the clicked card even when the
 * page is reloaded rather than restored from the back/forward cache.
 */
(function () {
  'use strict';

  // The #product-<id> fragment from product cards is stripped in layout/theme.liquid
  // (<head>), before the browser can jump to it, for every product template.

  var KEY = 'peleton:pdp-back-context';
  var MAX_AGE = 2 * 60 * 60 * 1000; // a browsing session, not forever

  function readStore() {
    try {
      var raw = sessionStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeStore(value) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(value));
    } catch (e) {}
  }

  function referrerUrl() {
    if (!document.referrer) return null;
    try {
      var url = new URL(document.referrer);
      return url.origin === location.origin ? url : null;
    } catch (e) {
      return null;
    }
  }

  function samePath(a, b) {
    if (!a || !b) return false;
    return a.replace(/\/+$/, '').toLowerCase() === b.replace(/\/+$/, '').toLowerCase();
  }

  // Menu headings are often written in capitals ("SHOP EFTER KATEGORI");
  // a breadcrumb reads better in sentence case.
  function tidy(title) {
    var t = String(title || '').trim();
    if (t && t === t.toUpperCase() && /[A-Za-zÆØÅæøåÄÖÜäöü]/.test(t)) {
      t = t.charAt(0) + t.slice(1).toLowerCase();
    }
    return t;
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function init() {
    var nav = document.querySelector('[data-product-back-link]');
    var configNode = document.querySelector('script[data-product-back-link-config]');
    if (!nav || !configNode || nav.hasAttribute('data-ready')) return;
    nav.setAttribute('data-ready', '');

    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (e) {
      return;
    }

    var ref = referrerUrl();
    var stored = readStore();
    if (stored && (!stored.at || Date.now() - stored.at > MAX_AGE)) stored = null;

    var context = null; // { path, title, href, direct }

    if (config.serverUrl && config.serverTitle) {
      context = {
        path: config.serverUrl,
        title: config.serverTitle,
        href: config.serverUrl,
        direct: !!(ref && samePath(ref.pathname, config.serverUrl))
      };
      if (context.direct) context.href = ref.pathname + ref.search;
    } else if (stored && ref) {
      var fromCollection = samePath(ref.pathname, stored.path);
      var fromTrailProduct = !!stored.product && samePath(ref.pathname, stored.product);
      if ((fromCollection || fromTrailProduct) && stored.title) {
        context = {
          path: stored.path,
          title: stored.title,
          href: stored.href || stored.path,
          direct: fromCollection
        };
      }
    }

    if (context) {
      // Keep the trail alive for the next product (recommendations etc.).
      writeStore({
        path: context.path,
        title: context.title,
        href: context.href,
        product: location.pathname,
        at: Date.now()
      });
    }

    var link = nav.querySelector('[data-back-target]');
    if (!link) return;

    if (context && !samePath(context.path, config.defaultUrl)) {
      render(nav, config, context);
      link = nav.querySelector('[data-back-target]');
    } else if (context) {
      // Came from the catalogue itself: same label, but return to the exact
      // spot in it.
      link.setAttribute('href', context.href);
    }

    if (!context) return;
    var useHistory = context.direct && window.history.length > 1;
    nav.querySelectorAll('[data-back-target]').forEach(function (target) {
      target.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        // Tell the collection page (assets/collection-load-more.js) this is a
        // return, not a fresh visit: it rebuilds the loaded pages and scrolls
        // back to the product card, also when the browser does a full reload
        // instead of a back/forward-cache restore, or we navigate to the href.
        try {
          sessionStorage.setItem('clm:return', JSON.stringify({ href: target.getAttribute('href') || context.href, ts: Date.now() }));
        } catch (e) {}
        if (!useHistory) return;
        event.preventDefault();
        window.history.back();
      });
    });
  }

  function render(nav, config, context) {
    var titles = {};
    (config.parents || []).forEach(function (p) {
      titles[p.u.toLowerCase()] = p.t;
    });

    var parentUrls = (config.map || {})[context.path] || [];
    if (!parentUrls.length) {
      // Map keys keep the menu's casing; fall back to a case-insensitive match.
      var wanted = context.path.toLowerCase();
      Object.keys(config.map || {}).some(function (key) {
        if (key.toLowerCase() === wanted) {
          parentUrls = config.map[key];
          return true;
        }
        return false;
      });
    }

    var list = el('ol', 'pdp-backlink__trail');

    parentUrls.forEach(function (url) {
      var title = titles[url.toLowerCase()];
      if (!title || samePath(url, context.path)) return;
      var item = el('li', 'pdp-backlink__item pdp-backlink__item--parent');
      var a = el('a', 'pdp-backlink__link pdp-backlink__link--parent');
      a.href = url;
      a.appendChild(el('span', 'pdp-backlink__text', tidy(title)));
      item.appendChild(a);
      list.appendChild(item);
    });

    var current = el('li', 'pdp-backlink__item pdp-backlink__item--current');
    var link = el('a', 'pdp-backlink__link');
    link.href = context.href;
    link.setAttribute('data-back-target', '');
    current.appendChild(link);
    link.appendChild(el('span', 'pdp-backlink__text', tidy(context.title)));
    list.appendChild(current);

    // The product itself closes the trail: plain text, it is the page you are on.
    if (config.productTitle) {
      current.classList.add('pdp-backlink__item--has-next');
      link.classList.add('pdp-backlink__link--parent');
      var here = el('li', 'pdp-backlink__item pdp-backlink__item--product');
      here.setAttribute('aria-current', 'page');
      here.appendChild(el('span', 'pdp-backlink__text', config.productTitle));
      list.appendChild(here);
      nav.classList.add('pdp-backlink--with-product');
    }

    // The chevron means "back": it leads to the collection the visitor came
    // from (the last crumb), not to the first crumb. It is a duplicate of
    // that link, so it is hidden from assistive tech and the tab order.
    var chevron = nav.querySelector('.pdp-backlink__chevron');
    var back = el('a', 'pdp-backlink__back');
    back.href = context.href;
    back.setAttribute('data-back-target', '');
    back.setAttribute('aria-hidden', 'true');
    back.setAttribute('tabindex', '-1');
    if (chevron) back.appendChild(chevron.cloneNode(true));

    nav.textContent = '';
    nav.appendChild(back);
    nav.appendChild(list);
    nav.classList.add('pdp-backlink--trail');
  }

  // The snippet loads this file async, right after the nav and its config:
  // run as soon as they exist instead of waiting for DOMContentLoaded (which
  // waits for every deferred theme/app script). Until init runs the link is
  // the server default without the visitor's page/scroll context, so a quick
  // tap on it would land at the top of the catalogue.
  if (document.querySelector('script[data-product-back-link-config]')) {
    init();
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
